import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Mail } from "lucide-react";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import { formatTL, STORE_LINKS } from "../mock";

const STORES = [
  { id: "google-play", href: STORE_LINKS.googlePlay, Icon: FaGooglePlay, top: "HEMEN İNDİR", name: "Google Play" },
  { id: "app-store", href: STORE_LINKS.appStore, Icon: FaApple, top: "App Store'dan", name: "İndirin" },
];

const PaymentResultPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [reg, setReg] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/payments/${params.get("id")}`)
      .then(({ data }) => setReg(data))
      .catch(() => setFailed(true));
  }, [params]);

  if (!reg && !failed) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-neutral-400" />
      </div>
    );
  }

  const paid = reg?.status === "paid";

  return (
    <div data-testid="payment-result-page" className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        <div className={`w-20 h-20 rounded-full mx-auto flex items-center justify-center ${paid ? "bg-green-100" : "bg-red-100"}`}>
          {paid ? <CheckCircle2 className="w-10 h-10 text-green-600" /> : <XCircle className="w-10 h-10 text-red-600" />}
        </div>
        <h1 data-testid="payment-result-title" className="mt-6 text-2xl font-bold text-black">
          {paid ? "Ödemeniz Başarılı!" : "Ödeme Tamamlanamadı"}
        </h1>
        <p className="mt-3 text-sm text-neutral-500 leading-6">
          {paid ? (
            <>
              {reg.package_name} aboneliğiniz aktif edildi. Mobil uygulamadan telefon numaranız ve
              e-postanıza gelen geçici parolanızla giriş yapabilirsiniz.
            </>
          ) : (
            reg?.error_message || "Kartınızdan herhangi bir ücret çekilmedi. Lütfen bilgilerinizi kontrol edip tekrar deneyin."
          )}
        </p>
        {paid && (
          <>
            <div data-testid="email-info-notice" className="mt-6 flex items-start gap-3 bg-green-50 border border-green-200 rounded-2xl p-4 text-left">
              <Mail className="w-5 h-5 text-green-600 shrink-0 mt-0.5" />
              <p className="text-sm text-green-800 leading-5">
                Oturum bilgileriniz <span className="font-semibold">{reg.email}</span> adresine otomatik olarak
                gönderilmiştir. Lütfen e-posta adresinizi (gereksiz/spam klasörü dahil) kontrol ediniz.
              </p>
            </div>
            <div data-testid="store-download" className="mt-6">
              <p className="text-sm font-semibold text-black">
                Uygulamamızı Google Play ve App Store'dan indirebilirsiniz
              </p>
              <div className="mt-3 flex justify-center gap-3">
                {STORES.map(({ id, href, Icon, top, name }) => (
                  <a
                    key={id}
                    data-testid={`store-badge-${id}`}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2.5 bg-black text-white rounded-xl px-4 py-2.5 hover:bg-neutral-800 transition-colors"
                  >
                    <Icon className="w-6 h-6" />
                    <span className="text-left leading-tight">
                      <span className="block text-[9px] tracking-wide opacity-80">{top}</span>
                      <span className="block text-sm font-semibold">{name}</span>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </>
        )}
        {reg && (
          <div className="mt-6 bg-[#fafafa] border border-neutral-100 rounded-2xl p-5 text-left">
            <div className="flex justify-between text-sm">
              <span className="text-neutral-500">Paket:</span>
              <span className="font-semibold">{reg.package_name}</span>
            </div>
            <div className="flex justify-between text-sm mt-2">
              <span className="text-neutral-500">Tutar:</span>
              <span className="font-semibold">₺{formatTL(reg.amount)},00</span>
            </div>
          </div>
        )}
        <button
          data-testid="payment-result-home-btn"
          onClick={() => navigate("/tanitim")}
          className="mt-8 w-full bg-black text-white text-sm font-medium py-3.5 rounded-lg hover:bg-neutral-800 transition-colors"
        >
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
};

export default PaymentResultPage;
